const MAX_DELAY_MS = 14 * 24 * 60 * 60 * 1000

function validateFollowUpDelay(form, now = Date.now()) {
  const errors = {}
  const reason = String((form && form.reason) || '').trim()
  const untilValue = form && form.until
  const until = untilValue ? new Date(untilValue) : null

  if (!untilValue) {
    errors.until = 'Choose when the follow-up schedule should be delayed until.'
  } else if (!until || Number.isNaN(until.getTime())) {
    errors.until = 'Choose a valid delay end.'
  } else if (until.getTime() <= now) {
    errors.until = 'Delay end must be in the future.'
  } else if (until.getTime() > now + MAX_DELAY_MS) {
    errors.until = 'Follow-up automation can be delayed by no more than 14 days.'
  }

  if (!reason) {
    errors.reason = 'Explain why the follow-up schedule should be delayed.'
  }

  return errors
}

function isFollowUpDelayDateDisabled(value, now = Date.now()) {
  const candidate = new Date(value)
  if (Number.isNaN(candidate.getTime())) return true

  const firstDay = new Date(now)
  firstDay.setHours(0, 0, 0, 0)
  const lastDay = new Date(now + MAX_DELAY_MS)
  lastDay.setHours(23, 59, 59, 999)
  candidate.setHours(0, 0, 0, 0)
  return candidate < firstDay || candidate > lastDay
}

module.exports = {
  MAX_DELAY_MS,
  isFollowUpDelayDateDisabled,
  validateFollowUpDelay
}
